import BaseSvgIcon, { IconProps } from '@trustoo/components/ui/icon/BaseSvgIcon'

/**
 * Close icon component.
 * Displays an "X" shape, commonly used for close or dismiss actions.
 * If color is not provided, uses currentColor to inherit text color.
 */
const CloseIcon = (props: IconProps) => {
    return (
        <BaseSvgIcon {...props}>
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
        </BaseSvgIcon>
    )
}

export default CloseIcon
